var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-delete-dialog',{attrs:{"visivel":_vm.visivel,"tipo":"confirma","mensagem":"Excluir bloco","corpoMensagem":"Tem certeza que deseja excluir este bloco?"},on:{"close":function($event){return _vm.$emit('close')},"confirma":function($event){return _vm.$emit('confirma')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }